import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'app-link-device-to-member-dialog',
  templateUrl: './link-device-to-member-dialog.component.html',
  styleUrls: ['./link-device-to-member-dialog.component.css']
})
export class LinkDeviceToMemberDialogComponent implements OnInit {
  currentAccount: any;
  constructor(
    public dialogRef: MatDialogRef<LinkDeviceToMemberDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {
  }

  setAccount(acc: any) {
    this.currentAccount = acc;
  }

  link() {
    
  }
}



// WEBPACK FOOTER //
// ./src/app/link-device-to-member-dialog/link-device-to-member-dialog.component.ts